module.exports = __webpack_public_path__ + "img/insurance-cost.ab01d3d2.svg";